const numberFormshape = ['豹子', '三不同', '对子'];
const numberFormStr = ['bz', 'zl', 'dz']


const ks = (data) => {
  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        width: 170
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 70,
        render: (h, { row }) => {
          return (
            <div class="ball num">
              {row.ballList.map((x, i) => {
                return <span>{x}</span>;
              })}
            </div>
          );
        }
      },
      {
        title: '开奖号码分布',
        align: 'center',
        children: numberDistribution(data)
      },
      {
        title: '号码形态',
        align: 'center',
        width: 300,
        children: numberForm(data)
      },
      {
        title: '和值走势',
        align: 'center',
        children: valueTrend(data, Vue)
      }
    ];

    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 340
      }, {
        title: '开奖号码分布',
        align: 'center',
        children: statisticNumberFrom()
      }, {
        title: '号码形态',
        align: 'center',
        children: statisticNumberDistribution(Vue)
      }, {
        title: '和值走势',
        align: 'center',
        children: statisticValueTrend(Vue)
      }
    ];
    return arr;
  };
  return { list, lostList };
};
//数据统计和值走势
const statisticValueTrend = (Vue) => {
  const arr = []
  const num = Vue.statisticData.sumJson.nums //和值数据

  let keys = Object.keys(num);
  for (let i = 0; i < keys.length; i++) {
    const obj = {};
    obj.title = `${keys[i]}`;
    obj.align = 'center';
    obj.className = `lost_table_children_${i}`;

    obj.render = (h, row) => {

      let key = row.row.key;
      let n = num[keys[i]]


      if (key != 'averageOmit') {
        return <span>{n[key] ? n[key] : 0}</span>;
      }
    };
    arr.push(obj);
  }
  return arr;

};
//数据统计号码形态
const statisticNumberDistribution = (Vue) => {

  const arr = [];
  for (let i = 0; i < 3; i++) {
    const obj = {};
    obj.title = `${numberFormshape[i]}`;
    obj.align = 'center';
    obj.width = 50
    obj.className = `lost_table_children_${i}`;
    obj.render = (h, row) => {

      let val = Vue.statisticData.form_json.front.join
      let key = row.row.key;
      let n = val[numberFormStr[i]];

      if (key != 'averageOmit') {
        return <span>{n[key] ? n[key] : 0}</span>;
      }
    };
    arr.push(obj);
  }
  return arr;
}
//数据统计号码分布
const statisticNumberFrom = () => {
  const arr = [];
  for (let i = 1; i < 7; i++) {
    const obj = {};
    obj.title = `${i}`;
    obj.align = 'center';
    obj.className = `lost_table_children_${i}`;
    obj.render = (h, row) => {
      let key = row.row.key;
      let n = row.row.lost.numSpread.nums[i];
      if (key != 'averageOmit') {
        return <span>{n[key] ? n[key] : 0}</span>;
      }
    };
    arr.push(obj);
  }
  return arr;
}
const valueTrend = (data) => {
  const arr = []
  if (data) {
    let a = data[0].sum_json.nums;
    let keys = Object.keys(a);
    for (let i = 0; i < keys.length; i++) {
      const obj = {};
      obj.title = `${keys[i]}`;
      obj.align = 'center';

      obj.className = `tree_table_children`;
      obj.render = (h, row) => {
        let num = row.row.sum_json.nums[keys[i]];
        if (num == 0) {
          return <span class="blue">{row.row.sum_json.sum}</span>;
        } else if (data[0].sum_json.nums[keys[i]] > row.index) {
          return <span class="divide_lost_info lost_info">{num}</span>;
        } else {
          return <span class="lost_info">{num}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
const numberForm = data => {
  const arr = [];
  if (data) {
    for (let i = 0; i < numberFormshape.length; i++) {
      const obj = {};
      obj.title = `${numberFormshape[i]}`;
      obj.align = 'center';
      obj.width = 50;

      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        let num = data[0].form_json.front.join[numberFormStr[i]];
        let val = row.row.form_json.front.join[numberFormStr[i]]
        if (val == 0) {
          return (
            <div class="hot">
              <span class={`table_join_red_${i % 2}`}>{numberFormshape[i]}</span>
            </div>
          );
        } else if (num > row.index) {
          return <span class="divide_lost_info lost_info">{val}</span>;
        } else {
          return <span class="lost_info">{val}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
const numberDistribution = data => {
  const arr = [];
  if (data) {
    for (let i = 1; i < 7; i++) {
      var obj = {};
      obj.title = `${i}`;
      obj.align = 'center';
      obj.className = `tree_table_children`;
      obj.render = (h, row) => {

        let num = data[0].ball_json.numSpread.nums[i];
        if (row.row.ball_json.numSpread.nums[i] == 0) {
          return (
            <div class="hot">
              {row.row.numDistribute[i] > 1 ? <span class="badge">{row.row.numDistribute[i]}</span> : ''}
              <span class="table_red">{i}</span>
            </div>
          );
        } else if (num > row.index) {
          return <span class="divide_lost_info lost_info">{row.row.ball_json.numSpread.nums[i]}</span>;
        } else {
          return <span class="lost_info">{row.row.ball_json.numSpread.nums[i]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};


export default ks;



// WEBPACK FOOTER //
// ./src/pages/Trend/KSjibenzoushi/columns/index.js